import React from "react";

import { Sidebar } from "src/components/sidebar/Sidebar";
import { SidebarProvider } from "src/contexts/SidebarContext";
import { ShellContainer } from "src/components/layout/ShellContainer";
import { ShellContentFrame } from "src/components/layout/ShellContentFrame";
import { TooltipProvider } from "src/components/ui/tooltip";

/**
 * AppShell wraps every authenticated page.
 *
 *   <AppShell>
 *     <YourPageContent />
 *   </AppShell>
 *
 * - SidebarProvider exposes collapse state to all sidebar components.
 * - TooltipProvider is required by Radix Tooltip; set once here.
 */
export function AppShell({ children }) {
  return (
    <TooltipProvider delayDuration={200}>
      <SidebarProvider>
        <ShellContainer>
          <Sidebar />
          <ShellContentFrame>{children}</ShellContentFrame>
        </ShellContainer>
      </SidebarProvider>
    </TooltipProvider>
  );
}

